import { MessageCategoryOption } from '@pandiafi/components'

import { MessageCategory } from '../../../common/validations/residentMessageTimelineSchema'

export const getMessageCategoryLabel = (
  category: MessageCategory,
  language: string
) =>
  language.startsWith('sv')
    ? category.nameSv
    : language.startsWith('en')
      ? category.nameEn
      : category.nameFi

export const getReadOnlyMessageCategoryOptions = (
  category: MessageCategory | null | undefined,
  selectableCategories: MessageCategory[],
  language: string,
  noCategoryLabel: string
): MessageCategoryOption[] => [
  { value: '', label: noCategoryLabel },
  ...selectableCategories.map((selectableCategory) => ({
    value: String(selectableCategory.id),
    label: getMessageCategoryLabel(selectableCategory, language),
  })),
  ...(category && !selectableCategories.some(({ id }) => id === category.id)
    ? [
        {
          value: String(category.id),
          label: getMessageCategoryLabel(category, language),
        },
      ]
    : []),
]
